import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import { App } from './App';
import './shell.css';
import { startDmyDateInputs } from './ui/dmyDate';

const rootEl = document.getElementById('bh-root')!;
// Keys typed in Bhorosha's own dialogs must not trigger the original app's
// keyboard shortcuts (e.g. Delete = delete selected medicine).
rootEl.addEventListener('keydown', e => e.stopPropagation());

// No <StrictMode>: the original screens are mounted once per page.
createRoot(rootEl).render(<App />);

// All date boxes show and take DD/MM/YYYY (not the computer's mm/dd/yyyy).
startDmyDateInputs();

// Installable app + offline support. Updates apply on the next visit.
registerSW({ immediate: true });
